import Axios from 'axios';
import header from './auth/header'

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 =  process.env.API_URL + '/api/v3/';

class UserProfile {
  // update(data) {
  //   return Axios.patch(API_URL + 'update-profile', data, { headers: header() });
  // }
  update(data) {
    return Axios.post(API_URL_V3 + 'users/personal/profile', data, { headers: header() });
  }

  updateV3(data) {
    return Axios.patch(API_URL + 'users/personal/profile', data, { headers: header() });
  }
}

export default new UserProfile();



// WEBPACK FOOTER //
// ./src/api/userprofile.js